import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type NurseryData = {
  id: string;
  name: string;
  address: string;
  phone: string;
};

interface NurseryEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  nursery: NurseryData | null;
  onNurseryChange: (nursery: NurseryData) => void;
  onSave: () => void;
  isPending: boolean;
}

const NurseryEditDialog = ({ open, onOpenChange, nursery, onNurseryChange, onSave, isPending }: NurseryEditDialogProps) => {
  if (!nursery) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" dir="rtl">
        <DialogHeader>
          <DialogTitle>تعديل بيانات الحضانة</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>اسم الحضانة</Label>
            <Input value={nursery.name} onChange={(e) => onNurseryChange({ ...nursery, name: e.target.value })} />
          </div>
          <div>
            <Label>العنوان</Label>
            <Input value={nursery.address} onChange={(e) => onNurseryChange({ ...nursery, address: e.target.value })} />
          </div>
          <div>
            <Label>الهاتف</Label>
            <Input value={nursery.phone} onChange={(e) => onNurseryChange({ ...nursery, phone: e.target.value })} dir="ltr" />
          </div>
          <Button onClick={onSave} disabled={isPending} className="w-full">
            {isPending ? "جاري الحفظ..." : "حفظ التعديلات"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NurseryEditDialog;
